import { CircularProgress } from '@mui/material';
import { typographyToCss } from 'shared/lib/mui';
import { QueryNavLink } from 'shared/lib/react-router-dom';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  height: 100dvh;
  width: 100vw;
  padding: ${({ theme }) => theme.spacing(6)};
`;

export const Body = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  margin: 0 auto;
  max-width: 100%;
`;

export const BodyContent = styled.div`
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(6)};

  min-width: 0;
  width: 32rem;
  max-width: 32rem;
`;

export const Anchor = styled(QueryNavLink)`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
  color: ${({ theme }) => theme.palette.primary.main};
  text-align: center;
`;

export const Loader = styled(CircularProgress)``;
